import { momentTZ } from '@/helpers/moment';
import { getParameterByName } from '@/helpers/url';
import { i18n } from '@/helpers/i18n';
import { load } from '@/helpers/storage';
const actions = {
    async init({ commit, dispatch }) {
        let resErr = null;
        // init configPre - initialize config used by other modules
        await dispatch('config/initPre');
        // load timezone if possible
        await dispatch('setTimezone');
        // ==================================================================================== \\
        // =================================== Load Language ================================== \\
        // ==================================================================================== \\
        // const langReq = ((new URL(window.location)).searchParams.get('l')) || load('lang', 'en')
        const langReq = getParameterByName('l') || load('lang', 'en');
        if (langReq) {
            commit('setState', { val: 'stores.root.loadingLanguage', err: langReq });
            try {
                await dispatch('setLang', langReq);
            }
            catch (err) {
                console.log('error loading lang', langReq, err);
            }
            commit('clearState');
        }
        // ==================================================================================== \\
        // ===================================== Do Login ===================================== \\
        // ==================================================================================== \\
        try {
            await dispatch('auth/login');
        }
        catch (err) {
            resErr = err;
        }
        // ==================================================================================== \\
        // ================================== init nav store ================================== \\
        // ==================================================================================== \\
        try {
            await dispatch('nav/init');
        }
        catch (err) {
            resErr = err;
        }
        await dispatch('config/initPost');
        if (resErr)
            throw resErr;
    },
    async setTimezone({ commit }, tzName) {
        tzName = tzName || momentTZ.tz.guess(true);
        commit('setTZName', tzName);
    },
    async setLang({ commit }, lang) {
        if (lang && !i18n.messages[lang]) {
            try {
                let res = await import('@/locales/' + lang + '.json');
                i18n.setLocaleMessage(lang, res.default);
                commit('setLang', lang);
            }
            catch (err) {
                throw err;
            }
        }
        else {
            commit('setLang', lang);
        }
    },
    async gotoDBTrackWeb({ commit }) {
        commit('setState', 'Loading');
        setTimeout(() => {
            window.location.href = String(process.env.VUE_APP_WEBSITE_URL);
        }, 1);
    }
};
export default actions;
